import { Modal, Spin } from 'antd';
import styled from 'styled-components';
import DatePicker from './DatePicker';
import CallerIdHistoryTable from './CallerIdHistoryTable';
import { IApiHistoryCallerIdParams } from 'services/types/caller';
import { IUICallerIdHistoryItem } from 'types/customer';
type Props = {
  visible?: boolean;
  onClose: () => void;
  params: IApiHistoryCallerIdParams;
  onChange: (params: Partial<IApiHistoryCallerIdParams>) => void;
  dataSource: IUICallerIdHistoryItem[];
  loading?: boolean;
  totalItems: number;
  onChangePage: (page: number) => void;
};
const CallerIdHistoryModal = ({ visible, onClose, dataSource, params, onChange, loading, totalItems, onChangePage }: Props) => {
  return (
    <Modal open={visible} footer={<></>} closable={false} closeIcon={null} width={'1100px'} destroyOnClose={false}>
      <Container>
        <Header>
          <span>History Caller ID</span>
        </Header>
        <Body>
          <Filter>
            <DatePicker params={params} onChange={onChange} />
          </Filter>
          <CallerIdHistoryTable
            params={params}
            loading={loading}
            dataSource={dataSource}
            totalItems={totalItems}
            onChangePage={onChangePage}
          />
        </Body>
        <Footer>
          <button onClick={onClose} type='button' className="btn"><span>CLOSE</span></button>
        </Footer>
      </Container>
    </Modal>
  );
};

export default CallerIdHistoryModal;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  background: #F8F9FE;
`;
const Header = styled.div`
  display: flex;
  height: 56px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-bottom: 1px solid #148CF1;
  background: #E8F3FF;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
  span {
    align-self: stretch;
    color: #1D2129;
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
  }
`;
const Body = styled.div`
  display: flex;
  padding: 32px 24px 16px 24px;
  align-items: center;
  flex-direction: column;
  gap: 24px;
  align-self: stretch;
  background: #fff;
`;

const Filter = styled.div`
  display: flex;
  align-self: stretch;
`;

const Footer = styled.div`
  display: flex;
  padding: 24px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  button.btn {
    display: flex;
    padding: 16px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    border-radius: 4px;
    background: #CCD4DC;
    box-shadow: 0 4px 8px -3px rgba(45, 35, 66, 0.30);

    &:active {
      opacity: 0.6;
    }

    span {
      color: #1D2129;
      text-align: center;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    &.btn-submit {
      background: #00A140;
      span {
        color: #ffffff;
      }
    }
  }
`;
